// Validate the given value against a true JS object

export const isObject = (value: unknown) => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
